import { render, staticRenderFns } from "./404.vue?vue&type=template&id=f6a4a096&scoped=true&"
import script from "./404.vue?vue&type=script&lang=coffee&"
export * from "./404.vue?vue&type=script&lang=coffee&"
import style0 from "./404.vue?vue&type=style&index=0&id=f6a4a096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a4a096",
  null
  
)

export default component.exports